class Accordion {
    constructor (context, settings, $) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;

        this.$outerContainer = this.$('.js-accordion', this.context).once();
        this.$heading = this.$('.js-accordion-heading', this.context).once();
        this.$contentClass = this.$('.js-accordion-content', this.context).once();

        this.$heading.on('click', $.proxy(this.toggleOpen, this));
    }

    toggleOpen (e) {
        const $elem = this.$(e.currentTarget);

        $elem.toggleClass('is-clicked').attr('aria-expanded', 'true');

        if (!$elem.hasClass('is-clicked')) {
            $elem.attr('aria-expanded', 'false');
            $elem.next('.js-accordion-content').slideUp();
        } else {
            $elem.next('.js-accordion-content').slideDown();

            // Wrapping table in accordion to stop overflowing.
            if (!$elem.data('isWrapped')) {
                setTimeout(() => {
                    const $tables = $elem.next('.js-accordion-content').find('table');

                    $tables.each((i, e) => {
                        const $table = this.$(e);

                        if ($table.width() > this.$outerContainer.width()) {
                            $table.wrap('<div class="wide-table"><div class="wide-table-inner"></div></div>');
                        }
                    });

                    $elem.data('isWrapped', true); // Set this to true to indicate wrapping
                }, 0);
            }
        }
    }
}

export default Accordion;
